export default "__VITE_ASSET__ba972be5__"